import React from 'react'
import styled from 'styled-components'
import breakpoint from 'styled-components-breakpoint'

const Column = styled.div`
  display: block;
  
  box-sizing: border-box;
  ${props => !props.division && `flex-basis: 0;`}
  ${props => !props.division && `flex-grow: 1;`}
  ${props => !props.division && `flex-shrink: 1;`}
  ${props => props.division && `flex: none;`}
  ${props => props.division && `width: ${100 / props.mobile}%;`};
  ${props =>
    props.order && props.order.mobile && `order: ${props.order.mobile};`};


  ${breakpoint('tablet')`
    padding: ${props =>
      props.theme.space[4] * props.rowSpacing}px ${props =>
    props.theme.space[4] * props.columnSpacing}px;
    ${props => props.division && `width: ${100 / props.tablet}%;`}
    ${props =>
      props.order && props.order.mobile && `order: ${props.order.tablet};`};
    flex-direction: row;
  `}

  ${breakpoint('desktop')`
    ${props => props.division && `width: ${100 / props.desktop}%;`}
    ${props =>
      props.order && props.order.mobile && `order: ${props.order.desktop};`};
  `}
`

export default ({
  children,
  division,
  order,
  columnSpacing = 1,
  rowSpacing = 1,
}) => {
  return (
    <Column
      division={division}
      mobile={division !== undefined ? division.mobile : 1}
      tablet={
        division !== undefined ? division.tablet || division.desktop : null
      }
      desktop={
        division !== undefined ? division.desktop || division.tablet : null
      }
      order={order}
      columnSpacing={columnSpacing}
      rowSpacing={rowSpacing}
    >
      {children}
    </Column>
  )
}
